import { Tooltip } from '@cotera/client/app/components';
import { ReadonlyWatchable, useWatchableValue } from '../../actions/framework';
import { CloseTabButton } from './close-tab';
import { Text } from '@cotera/client/app/components';
import { startCase } from 'lodash';

export const ChangeIndicator: React.FC<{
  tabId: string;
  model: {
    changes: ReadonlyWatchable<Record<string, boolean | string>>;
  };
  onClose?: (tabId: string) => boolean;
}> = ({ tabId, model, onClose }) => {
  const changes = useWatchableValue(model.changes);

  return Object.values(changes).some((v) => v !== false) ? (
    <Tooltip
      side="bottom"
      tooltipContent={
        <div className="flex flex-col gap-2">
          <Text.Title type="label">Changes</Text.Title>
          <ul>
            {Object.entries(changes)
              .filter(([_key, value]) => value !== false)
              .map(([key, value], index) => (
                <li
                  key={key}
                  className="max-w-[200px] overflow-hidden text-ellipsis"
                >
                  {index + 1}. {startCase(key)}
                  {typeof value === 'string' ? `: ${value}` : ''}
                </li>
              ))}
          </ul>
        </div>
      }
    >
      <div className="h-6 w-6 relative group cursor-pointer rounded transition-all duration-300">
        <div
          className={`w-2 h-2 bg-primary rounded-full absolute top-[50%] left-[50%] 
          transition-all duration-300 group-hover:opacity-0 group-hover:scale-0 
          translate-x-[-50%] translate-y-[-50%]`}
        />
        <CloseTabButton tabId={tabId} onClose={onClose} />
      </div>
    </Tooltip>
  ) : (
    <CloseTabButton tabId={tabId} onClose={onClose} />
  );
};
